function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M79.37 171.39a4 4 0 004 4.61h25a4 4 0 004-4.61L95.93 57.5z",
  fill: "#f4f4f4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M152.54 124.52a2.14 2.14 0 01-1.58-3.58l.15-.15A70.66 70.66 0 00151 21a2.15 2.15 0 013-3 75 75 0 010 105.9 2.19 2.19 0 01-1.46.62z",
  fill: "#e60000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M137 110.06a2.14 2.14 0 01-1.52-3.66 49.91 49.91 0 000-70.5 2.14 2.14 0 113-3 54.21 54.21 0 010 76.56 2.14 2.14 0 01-1.48.6z",
  fill: "#e60000"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M121.66 94.56a2.15 2.15 0 01-1.52-3.66 28.14 28.14 0 000-39.69 2.15 2.15 0 013-3 32.44 32.44 0 010 45.75 2.14 2.14 0 01-1.48.6zM39.3 124.54a2.09 2.09 0 01-1.49-.62 74.89 74.89 0 010-105.92 2.15 2.15 0 113 3 70.59 70.59 0 000 99.84 2.16 2.16 0 01-1.51 3.69z",
  fill: "#e60000"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M54.9 110.06a2.14 2.14 0 01-1.52-.63 54.21 54.21 0 010-76.56 2.15 2.15 0 013 3 49.91 49.91 0 000 70.5 2.14 2.14 0 01-1.52 3.66z",
  fill: "#e60000"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M70.2 94.56a2.14 2.14 0 01-1.52-.63 32.44 32.44 0 010-45.75 2.15 2.15 0 013 3 28.14 28.14 0 000 39.69 2.15 2.15 0 01-1.52 3.66z",
  fill: "#e60000"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M175.88 69.92a74.68 74.68 0 01-21.88 54 2.14 2.14 0 01-3.4-2.52 2.12 2.12 0 003.4.52 74.65 74.65 0 0021.88-52zM138.47 109.43a2.14 2.14 0 01-3.4-2.52 2.12 2.12 0 003.4.52 53.94 53.94 0 0015.81-37.28 54 54 0 01-15.81 39.28zM123.2 91.88A32.11 32.11 0 00132.64 70v1a32.13 32.13 0 01-9.47 22.93 2.14 2.14 0 01-3.4-2.52 2.09 2.09 0 001.89 1.14 2.14 2.14 0 001.54-.67zM39.32 122.54a2.09 2.09 0 001.89-1.14 2.14 2.14 0 01-3.4 2.52 74.68 74.68 0 01-21.88-54 74.65 74.65 0 0021.88 52 2.14 2.14 0 001.52.63zM54.9 108.05a2.09 2.09 0 001.89-1.14 2.14 2.14 0 01-3.4 2.52 54 54 0 01-15.81-39.28 53.94 53.94 0 0015.8 37.28 2.14 2.14 0 001.52.63zM70.22 92.5a2.09 2.09 0 001.89-1.14 2.14 2.14 0 01-3.4 2.52A32.13 32.13 0 0159.25 71v-1a32.11 32.11 0 009.43 21.92 2.14 2.14 0 001.52.63z",
  fill: "#bd0000"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M95.93 73a2 2 0 01-2-2V45.22a2 2 0 114 0V71a2 2 0 01-2 2z",
  fill: "#4a4d4e"
});

var SvgNetworkSignalHi = function SvgNetworkSignalHi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "b4bf8ba6-3dd5-4c90-8e8d-dcb2f64d4d84"
  }, _ref, /*#__PURE__*/React.createElement("path", {
    d: "M112.47 171.39a4 4 0 01-4 4.61h-25a4 4 0 01-4-4.61l.07-.48a4 4 0 003.88 3.09h25a4 4 0 003.88-3.09z",
    fill: "#e6e6e6",
    style: {
      isolation: "isolate"
    }
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9));
};

export default SvgNetworkSignalHi;